<template>
	<div class="flex items-center ps-3">
		<span v-for="(page, i) in pages" :key="i" class="items-cente flex">
			<nuxt-link
				v-if="page.page"
				class="text-neutral-900 me-3 flex h-8 w-8 items-center justify-center rounded-xl text-xs"
				:class="{
					'bg-black pointer-events-none bg-opacity-5 font-bold': page.page === current,
					'bg-white cursor-pointer': page.page !== current
				}"
				:to="createLink(page.page)"
			>
				{{ page.page }}
			</nuxt-link>
			<span v-else class="me-3 flex items-center">
				<span class="bg-neutral-900 me-1 h-1 w-1 rounded-full" />
				<span class="bg-neutral-900 me-1 h-1 w-1 rounded-full" />
				<span class="bg-neutral-900 h-1 w-1 rounded-full" />
			</span>
		</span>
	</div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "#vue-router"

const app = useNuxtApp()

const props = withDefaults(
	defineProps<{
		total: number
		limit: number
		current: number
		link: (page: number) => RouteLocationRaw
	}>(),
	{
		current: 1
	}
)

const max = computed(() => Math.ceil(props.total / props.limit))

const pages = computed(() => {
	const pages = Array(11)
		.fill("")
		.map((_, i) => ({
			page: (props.current + (i - 5)) as any
		}))
		.filter((v) => v.page > 0)
		.filter((v) => v.page <= max.value)
	if (!pages.length) return pages
	if (pages[0].page !== 1) pages[0].page = 1
	if (pages[pages.length - 1].page !== max.value) pages[pages.length - 1].page = max.value
	if (props.current < max.value - 4) pages[pages.length - 2].page = null
	if (props.current > 5) pages[1].page = null
	return pages
})

const createLink = (i: number) => {
	if (typeof props.link(i) === "string") {
		return {
			path: props.link(i),
			query: app._route.query
		}
	} else {
		return props.link(i)
	}
}
</script>
